import { render, staticRenderFns } from "./create_business_account5.vue?vue&type=template&id=d4a78296&scoped=true"
import script from "./create_business_account5.vue?vue&type=script&lang=js"
export * from "./create_business_account5.vue?vue&type=script&lang=js"
import style0 from "./create_business_account5.vue?vue&type=style&index=0&id=d4a78296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a78296",
  null
  
)

export default component.exports